module.exports = __webpack_public_path__ + "static/dorin-minea-8d3c6534478ac0849839bd81ef98029d.jpg";